module.exports = {
    "breadcrumbs": `\u{130}\xe7erik haritalar\u{131}`
};


//# sourceMappingURL=tr-TR.main.js.map
